import {Component, EventEmitter, Output} from '@angular/core';

@Component({
    selector: 'zah-clientnummer-qr-scan',
    templateUrl: './clientnummer-qr-scan.component.html',
    styleUrls: ['./clientnummer-qr-scan.component.scss'],
    standalone: false
})
export class ClientnummerQrScanComponent {

  @Output()
  scanSuccess: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  scanError: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  noCamerasFound: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  noCameraPermission: EventEmitter<void> = new EventEmitter<void>();

  qrScannerEnabled = false;
  private lastClientnummerScanned: string;

  enableQrScanner(): void {
    this.qrScannerEnabled = true;
  }

  disableQrScanner(): void {
    this.qrScannerEnabled = false;
  }

  isQrScannerEnabled(): boolean {
    return this.qrScannerEnabled;
  }

  onQrScanSuccess(clientnummer: string): void {
    if (this.lastClientnummerScanned !== clientnummer) {
      this.lastClientnummerScanned = clientnummer;
      this.disableQrScanner();
      this.scanSuccess.next(clientnummer);
    }
  }

  onQrScanError(): void {
    this.scanError.emit();
  }

  onQrNoCamerasFound(): void {
    this.noCamerasFound.emit();
  }

  onQrCameraPermission(permission: boolean): void {
    if (!permission) {
      this.noCameraPermission.emit();
    }
  }
}
